import clsx from 'clsx';
import { ValidateEmail } from 'core/utils/utils';
import { Hr } from 'ui';
import Logo from 'core/modules/atoms/Logo/Logo';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import FormField from 'ui/molecules/FormField/FormField';
import InputText from 'ui/atoms/InputText/InputText';

const SignUpStepAuthorization = ({ t, onChangeDisabledButton, changeAuthorization, authorization, changeUser, user, layoutRight, step = 3 }) => {
  const [showParentConsent, setShowParentConsent] = useState(false);
  const [birthdayError, setBirthdayError] = useState(false);
  const [parentEmailError, setParentEmailError] = useState(false);

  useEffect(() => {
    onChangeDisabledButton(true);
  }, []);

  useEffect(() => {
    onChangeDisabledButton(!validate());
  }, [authorization]);

  function validate() {
    let years = moment().diff(user.birthdate, 'years', true);
    return authorization && (!authorization.need || (authorization.need && ValidateEmail(authorization.parentEmail))) && years < 100;
  }

  function onChange(e) {
    setParentEmailError(false);
    changeAuthorization({ ...authorization, parentEmail: e.target.value });
  }

  // El error se avisa al salir del campo, no en cada pulsación.
  function onBlurParentEmail(e) {
    if (e.target.value && !ValidateEmail(e.target.value)) setParentEmailError(t('login:Invalid email'));
  }

  function onChangeUser(e) {
    // En hora local, como el `max` del selector: `new Date('YYYY-MM-DD')` es medianoche UTC.
    const years = moment().diff(moment(e.target.value, 'YYYY-MM-DD'), 'years', true);
    if (years >= 3 && years < 80) {
      setBirthdayError(false);
      changeUser({ ...user, birthdate: e.target.value });
    } else {
      setBirthdayError(t('Please enter a valid birthday'));
      setShowParentConsent(false);
      changeUser({ ...user, birthdate: undefined });
    }
  }

  useEffect(() => {
    if (user.birthdate) {
      let years = moment().diff(user.birthdate, 'years', true);
      if (years < 14) {
        setShowParentConsent(true);
        changeAuthorization({ ...authorization, need: true });
      } else {
        setShowParentConsent(false);
        changeAuthorization({ ...authorization, need: false });
      }
    } else {
      onChangeDisabledButton(true);
    }
  }, [user.birthdate]);

  return (
    <div className="signup-step-license signup-step-license--authorization">
      <div className="signup__step">
        <div className="signup__column1">
          <div className="signup__step-content">
            <div className="signup__logo">
              <Logo size="big" />
            </div>
            <h1 className="signup__header" tabIndex={-1}>
              <span className="signup__titlepart2">{t('Authorization')}&nbsp;</span>
            </h1>
            <span className="signup__description">{t('Due to data protection law we need to know your date of birth')}</span>

            <div className="signup__content">
              <div className="signup__line-with-text signup__item">
                <FormField
                  error={!!birthdayError}
                  errorMessage={birthdayError || undefined}
                  isRequired
                  label={t('signup:Date of birth')}
                >
                  <InputText type="date" onChange={onChangeUser} icon="cake" iconLeft={true} max={moment().subtract(3, 'years').format('YYYY-MM-DD')} />
                </FormField>
              </div>
            </div>
            {showParentConsent && (
              <>
                <div className="signup__item">
                  <Hr />
                </div>
                <h2 className="signup__header signup__item">
                  <span className="signup__titlepart1">
                    {t('Parent or')} <span className="signup__titlepart2">{t('legal guardian')}</span>
                  </span>
                </h2>

                <div className="signup__item">
                  <div className="signup__item">
                    <FormField error={!!parentEmailError} errorMessage={parentEmailError || undefined} isRequired label={t('profile:Email')}>
                      <InputText type="email" icon="email" iconLeft={true} onBlur={onBlurParentEmail} onChange={onChange} />
                    </FormField>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="signup__column2">
          {/* signup4 */}
          {layoutRight || <div className={clsx('signup__image', `signup__image--step${step}`)}></div>}
        </div>
      </div>
    </div>
  );
};

SignUpStepAuthorization.propTypes = {
  t: PropTypes.func,
  onChangeDisabledButton: PropTypes.func,
  changeAuthorization: PropTypes.func,
  authorization: PropTypes.object,
  changeUser: PropTypes.func,
  user: PropTypes.object,
  layoutRight: PropTypes.node,
  step: PropTypes.number,
};

export default withTranslation(['signup', 'profile', 'placeholder'])(SignUpStepAuthorization);
